import { create, get, update, getForTake } from '@/services/api/resources/trainings';
import { submitCourse } from '@/services/api/resources/trainings/course-take/actions';
import type { Course, CourseForm, CoursePlain, CourseTree } from '@/entities/trainings';
import { taskToPromise } from '@/ui/helpers/fpTsHelper';

export class CourseService {
  async create(courseForm: CourseForm): Promise<Course> {
    const response = await taskToPromise(create, courseForm);

    return {
      id: response.id,
      title: courseForm.title,
      description: courseForm.description,
    };
  }

  async load(id: number): Promise<CourseTree> {
    return taskToPromise(get, id);
  }

  async loadForTake(id: number): Promise<CoursePlain> {
    return taskToPromise(getForTake, id);
  }

  async update(id: number, courseTree: CourseTree): Promise<void> {
    await taskToPromise(update, id, courseTree);
  }

  async submitCourse(id: number): Promise<void> {
    await taskToPromise(submitCourse, id);
  }
}

// Export a singleton instance
export const courseService = new CourseService();
